// extracted by mini-css-extract-plugin
export var active = "_tz-1";
export var circle = "_tz-0";
export var completed = "_tz-2";
export var connector = "_tz-4";
export var connectorCompleted = "_tz-7";
export var connectorSpacer = "_tz-5";
export var iconStrokeOverride = "_tz-8";
export var labelContainer = "_tz-6";
export var pending = "_tz-3";